module.exports = __webpack_public_path__ + "static/img/banner4.206b715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner4.png
// module id = ibpE
// module chunks = 0